import useSWR, { mutate } from 'swr';
import useSWRMutation from 'swr/mutation';
import {
    ReviewPlanDetailDto,
    ReviewPlanGridRowDto,
    ReviewPlanUpdateDto,
} from '@interfaces-clean/review-plan.interface';
import { getData, postData } from '@apis/rest-client';

const urlPrefix = 'SubjectMonitoring/ReviewPlan';
const timeout = 30000;

export const ReviewPlanAPI = {
    useGetAll: (studyRef: string | null) =>
        useSWR(studyRef ? `${urlPrefix}/${studyRef}/GetAll` : null, (url) =>
            getData<ReviewPlanGridRowDto[]>(url, { timeout }),
        ),

    useGetById: (studyRef: string | null, recordId: number | null) =>
        useSWR(studyRef && recordId != null ? `${urlPrefix}/${studyRef}/GetById/${recordId}` : null, (url) =>
            getData<ReviewPlanDetailDto>(url, { timeout }),
        ),

    useUpdate: (studyRef: string | null, recordId: number | null) => {
        const key = studyRef && recordId != null ? `${urlPrefix}/${studyRef}/Update/${recordId}` : null;

        return useSWRMutation(key, async (url, { arg }: { arg: ReviewPlanUpdateDto }) => {
            const result = await postData<ReviewPlanUpdateDto, void>(url, { arg, timeout });

            // Invalidate queries involving updated Review Plan
            /* eslint-disable no-void */
            void mutate(`${urlPrefix}/${studyRef}/GetAll`);
            void mutate(`${urlPrefix}/${studyRef}/GetById/${recordId}`);
            /* eslint-enable no-void */

            return result;
        });
    },
} as const;
